import { render, staticRenderFns } from "./WorkshopView.vue?vue&type=template&id=73eece0c&"
import script from "./WorkshopView.vue?vue&type=script&lang=ts&"
export * from "./WorkshopView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports